import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import Button from 'components/UI/Button';
import LogoImg from 'assets/logos/logo.png';
import { ReactComponent as IdCardIcon } from 'assets/icons/digital-loan-id-card.svg';

const BiometricVerificationModal = ({
  literals,
  hasError,
  onClose,
  onRetry,
  onBack,
}) => (
  <Modal
    position='end'
    animation='slide-up-enter'
    onClose={hasError ? onBack : onClose}
    closeOnBackgroundClick={false}
    showCloseButton={false}
  >
    <div className='digital-loan-biometric-modal text-center'>
      <img
        className='digital-loan-biometric-modal__logo mx-auto mb-4'
        src={LogoImg}
        alt=''
      />
      {hasError ? (
        <>
          <h2 className='text-primary font-bold mb-3'>{literals.errorTitle}</h2>
          <p className='mb-4'>{literals.errorMessage}</p>
          <div className='digital-loan-biometric-modal__actions'>
            <Button text={literals.retry} onClick={onRetry} />
            <Button text={literals.back} type='secondary' onClick={onBack} />
          </div>
        </>
      ) : (
        <>
          <h2 className='text-primary font-bold mb-3'>{literals.title}</h2>
          <p className='mb-2'>{literals.description1}</p>
          <p className='mb-4'>{literals.description2}</p>
          <div className='digital-loan-biometric-modal__content'>
            <IdCardIcon
              className='digital-loan-biometric-modal__identity-icon mx-auto mb-3'
              aria-hidden='true'
            />
            <p className='digital-loan-biometric-modal__prompt mb-2'>
              {literals.prompt}
            </p>
          </div>
        </>
      )}
    </div>
  </Modal>
);

BiometricVerificationModal.propTypes = {
  literals: PropTypes.object.isRequired,
  hasError: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default BiometricVerificationModal;
